import { QSetReviewSummary } from '@exam-management/qset-review-subtask-review-result';
import { Flex } from '@shared/components';

export default function QSetReviewReviewResultPage() {
  return (
    <Flex
      sx={(theme) => ({
        p: theme.spacing(6),
        gap: theme.spacing(6),
        flexDirection: 'column',
        flex: 1,
      })}
    >
      <QSetReviewSummary />
    </Flex>
  );
}
